import { Button, Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React, { useEffect, useState } from 'react';
import './login.css';
import { useForm } from 'react-hook-form';
import { json, useNavigate, useSearchParams, useParams } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextFieldComponent from '../../components/TextField/TextField';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function ForgotPassword() {
	let navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [loading, setLoading] = useState(false);
	const [waitCssImg, setWaitCssImg] = useState(true);
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const tokenUrl = searchParams.get('token');
	const [department, setDepartment] = useState('');
	const [email, setEmail] = useState('');

	const { register, formState: { errors }, handleSubmit, setError, setValue } = useForm({
		defaultValues: {
			department: localStorage.getItem('department'),
		}
	});

	const togglePasswordVisibility = () => setShowPassword((show) => !show);
	const toggleConfirmPasswordVisibility = () => setShowConfirmPassword((show) => !show);

	const onSubmit = (d) => {
		setLoading(true);
		const body = {
			"email": email,
			"token": tokenUrl,
			"password": d.password,
			"password_confirmation": d.confirm_password,
		}
		const url = `https://${department}.${process.env.REACT_APP_FIREHOUSE_API_URL}/forgetPasswordOTPChangePassword`
		axios.post(url, body)
			.then(response => {
				toast.success("Password Changed Successfully")
				navigate('/');
			})
			.catch(response => {
				setLoading(false)
				toast.error(response?.response?.data?.message)
			});
	};

	useEffect(() => {
		const storedDepartment = localStorage.getItem('department');
		if (storedDepartment) {
			setDepartment(storedDepartment);
		}
		const storedEmail = localStorage.getItem('email');
		if (storedEmail) {
			setEmail(storedEmail);
		}
	}, []);

	return (
		<>
			<img src='/images/main-login-img-new.png' className='d-none' onLoad={() => setWaitCssImg(false)} />
			<div className='main-login' style={{ visibility: waitCssImg ? 'hidden' : 'visible' }}>
				<div className='login-content-box'>
					<div className='login-content'>

							<form onSubmit={handleSubmit(onSubmit)} className='login-width flex-grow-1 '>
								<div className='login-box'>
									<Grid container rowSpacing={2} columnSpacing={{ xs: 12, sm: 2, md: 3 }}>

										<Grid xs={12}>
											<Box sx={{ my: 2 }} >
												<img className='w-100 mb-3' src='/images/logo.svg' />
											</Box>
										</Grid>

										<Grid xs={12}>
											<TextFieldComponent
												register={register('password', { required: "Password is required" })}
												placeholder="Enter new password"
												label="New Password"
												type={showPassword ? 'text' : 'password'}
												endAdornment={
													<InputAdornment position="end">
														<IconButton
															onClick={togglePasswordVisibility}
															style={{ marginRight: "-5px" }}
															sx={{ color: 'white' }}
															aria-label="toggle password visibility"
														>
															{showPassword ? <Visibility sx={{ color: 'white' }} /> : <VisibilityOff sx={{ color: 'white' }} />}
														</IconButton>
													</InputAdornment>
												}
											/>
											{errors.password && <p style={{ color: 'red' }}>{errors.password?.message}</p>}
										</Grid>

										<Grid xs={12}>
											<TextFieldComponent
												register={register('confirm_password', { required: "Confirm Password is required" })}
												placeholder="Re-enter password"
												label="Confirm Password"
												type={showConfirmPassword ? 'text' : 'password'}
												endAdornment={
													<InputAdornment position="end">
														<IconButton
															onClick={toggleConfirmPasswordVisibility}
															style={{ marginRight: "-5px" }}
															sx={{ color: 'white' }}
															aria-label="toggle password visibility"
														>
															{showConfirmPassword ? <Visibility sx={{ color: 'white' }} /> : <VisibilityOff sx={{ color: 'white' }} />}
														</IconButton>
													</InputAdornment>
												}
											/>
											{errors.confirm_password && <p style={{ color: 'red' }}>{errors.confirm_password?.message}</p>}
										</Grid>

										<Grid xs={12}>
											<Box sx={{ my: 2 }}>
												<Button className='rounded-5 text-capitalize login-button' type='submit' fullWidth={true} variant="contained" color='error' disabled={loading}>
													{loading ? 'Loading' : 'Submit'}
												</Button>
											</Box>
										</Grid>
									</Grid>
								</div>
							</form>

						<Grid className='flex-grow-1 text-white d-flex align-items-end'>
							<p>
								Copyright <a className='textfeild_white' target='_blank' href='https://247software.cloud'>247software.cloud</a> 2023
							</p>
						</Grid>
					</div>
				</div>
			</div>
		</>
	);
}